export default __webpack_public_path__ + "static/media/portfolio-41-small.4bdf7742.jpg";